import React from 'react';
import { Text as BPText, TextProps as ITextProps } from '@blueprintjs/core';
import cc from 'classcat';

interface AutoTextProps extends ITextProps {
  lines?: number;
  className?: string;
  children?: any;
}

const AutoText: React.FC<AutoTextProps> = ({ lines, className, ...props }) => {
  if (!lines || lines === 1) {
    return <BPText {...props} />;
  }
  const classes = cc([
    `multiline-ellipsis-${lines}`,
    className ? className : undefined
  ]);
  return (
    <div className={classes} title={props.children}>
      {props.children}
    </div>
  );
};

export default AutoText;
